export const statusData: Record<string, { title: string; icon: string; color: string, name: string }> = {
    enCours: {
        title: "En cours de validation",
        icon: 'progress-check',
        color: '#f59e0b',
        name: 'En cours',
    },
    acceptee: {
        title: "Acceptées",
        icon: 'check-circle',
        color: '#059669',
        name: 'Acceptée',
    },
    refusee: {
        title: "Refusées",
        icon: 'close-circle',
        color: '#dc2626',
        name: 'Refusée',
    },
    annulee: {
        title: "Annulées par le service RH",
        icon: 'cancel',
        color: '#6b7280',
        name: 'Annulée',
    },
}

export function getStatusTitle(type: string, plural?: boolean) {
    return statusData[plural ? type.substring(0, type.length - 1) : type]?.title || type
}

export function getStatusIcon(type: string, plural?: boolean){
    return statusData[plural ? type.substring(0, type.length - 1) : type]?.icon ||'file-document'
}

export function getStatusColor(type: string, plural?: boolean){
    return statusData[plural ? type.substring(0, type.length - 1) : type]?.color ||'#3b82f6'
}

export function getStatusName(type: string, plural?: boolean){
    return statusData[plural ? type.substring(0, type.length - 1) : type]?.name ||'#3b82f6'
}
